// "Why Drawing is Great" content — shared by the in-app WhyDrawingPage and the
// prerendered /why-drawing/ SEO page (scripts/seo-pages.mjs), so the two never
// drift apart.

/** Kid-friendly one-liners, shown as big emoji cards. */
export const WHY_REASONS: { emoji: string; text: string }[] = [
  { emoji: "✏️", text: "Drawing makes your hands strong and ready for writing!" },
  { emoji: "💬", text: "When words are tricky, you can show how you feel with a picture." },
  { emoji: "🧠", text: "Turning real things into drawings helps your brain grow." },
  { emoji: "🧩", text: "If a drawing goes wonky, you learn to fix it and try again." },
  { emoji: "🌟", text: "Finishing a picture makes you feel proud and happy!" },
  { emoji: "🌈", text: "There's no wrong way to draw — your imagination is the boss!" },
  { emoji: "😌", text: "Colouring and drawing are calm, cosy and relaxing." },
  { emoji: "👨‍👩‍👧", text: "Drawing with someone you love is the best kind of fun." },
];

/** The fuller "For grown-ups" points (bold lead + explanation). */
export const WHY_PARENT_POINTS: { title: string; text: string }[] = [
  {
    title: "Builds motor skills.",
    text: "Holding crayons and pencils helps children refine their grip and wrist control — the hands-on coordination that lays the groundwork for early handwriting.",
  },
  {
    title: "Boosts communication.",
    text: "Children often picture ideas and feelings long before they can put them into words. Drawing gives them a way to express what they can't yet say.",
  },
  {
    title: "Supports thinking.",
    text: "Translating a 3D world onto a flat page develops spatial awareness, proportion and planning, and gives memory and problem-solving a workout.",
  },
  {
    title: "Teaches patience and problem-solving.",
    text: "When a drawing doesn't turn out as expected, children learn to adapt, correct and try a new approach — small, repeated practice at resilience.",
  },
  {
    title: "Sparks creativity.",
    text: "A blank page has no single right answer, so imagination leads and there's room to invent.",
  },
  {
    title: "Calms and connects.",
    text: "Drawing is naturally soothing and helps with big feelings — and drawing alongside a grown-up or sibling makes for lovely, screen-light time together.",
  },
  {
    title: "Grows confidence.",
    text: "Finishing a picture gives a real sense of accomplishment and pride in \"I made that.\"",
  },
];
